// Инициализация страницы Как купить

import initDetailsLightbox from '~/app/utils/initDetailsLightbox';
import scroll from '~/app/Common/Scroll/index';

/**
 * Инициализация страницы Как купить
 */
function main(): void
{
	scroll();
	
	const articleDetailsElements = document.querySelectorAll(
		'body>main>div.sections>section>details',
	) as NodeListOf<HTMLElement>;
	
	if ( articleDetailsElements.length !== 0 )
	{
		initDetailsLightbox( articleDetailsElements );
	}
}

/**
 * Module
 */
export {
	main as default,
};



// WEBPACK FOOTER //
// ./app/Routes/Buy/index.ts